<template>
  <div class="row">
    <div class="col-lg-12" style="padding: 20px 0px 20px 20px">
      <div class="main-card mb-3 card" style="margin-left: 10px">
        <div class="card-body">
          <div class="tab-content">
            <div id="home">
              <h5 class="card-title">
                Teacher Notice
                <div
                  class="sub_title"
                  style="
                    margin-bottom: 20px;
                    color: #333;
                    font-size: 13px;
                    border: 1px solid #ccc;
                    background: #f8f8f8;
                    height: 30px;
                    text-align: right;
                    position: absolute;
                    right: 20px;
                    top: 10px;
                    padding: 2px 10px;
                  "
                >
                  CAMPUS 게시판 → Teacher Notice
                </div>
              </h5>
              <p
                style="
                  font-size: 15px;
                  margin-top: 10px;
                  line-height: 25px;
                  color: #004279;
                  font-weight: 500;
                "
              >
                - 작성된 게시글은 학습관
                <span style="font-weight: bold; color: red"
                  >[Teacher Notice]</span
                >
                게시판에 게시됩니다.<br />
                -
                <span style="font-weight: bold; color: red"
                  >강사 계정에서 등록</span
                >된 게시글만 학습관에 보여집니다.<br />
                - 본인 작성글에 한해
                <span style="font-weight: bold; color: red">수정 및 삭제</span>
                가능합니다.
              </p>

              <query-grid :config="config" ref="qg">
                <template #actions>
                  <router-link
                    to="articles/new"
                    v-if="this.$root.guiPerm == 'ROOT' || this.etc.is_writable"
                    ><button class="btn btn-danger">글쓰기</button></router-link
                  >
                </template>
                <template #items="props">
                  <tr v-for="article in props.records" v-bind:key="article.id">
                    <td style="height: 48px">{{ article.id }}</td>
                    <td>{{ article.addi_data1 }}</td>
                    <td>
                      <router-link
                        :to="'/boards/teacher/articles/' + article.id"
                        >{{ article.title }}</router-link
                      >
                    </td>
                    <td>{{ article.writerName }}</td>
                    <td>{{ article.addi_data2 }}</td>
                    <td>{{ article.created_at }}</td>
                  </tr>
                </template>
              </query-grid>

              <div style="float: right">
                <router-link to="articles/new" v-if="this.etc.is_writable"
                  ><button class="btn btn-danger">글쓰기</button></router-link
                >
              </div>
              =
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import QueryGrid from "../components/QueryGrid.vue";
export default {
  components: {
    QueryGrid,
  },
  data: () => ({
    boards: {},
    etc: {
      board: {
        title: "",
      },
    },
    articles: [],
    selBoard: "",
    search: "",
    config: {
      name: "학습자료실",
      req_endpoint: "",
      default_limit: 20,
      search_fields: [
        {
          id: "date_filter",
          name: "날짜검색",
          type: "date",
          filter_type: {
            created_at: "등록일",
            updated_at: "수정일",
          },
        },
        {
          id: "search",
          name: "키워드검색",
          type: "text",
          placeholder: "제목으로 검색",
        },
      ],
      columns: [
        {
          id: "id",
          sortable: true,
          name: "번호",
          excel_print: (v) => {
            return v.id;
          },
        },
        {
          id: "type",
          sortable: true,
          name: "Type",
          excel_print: (v) => {
            return v.type;
          },
        },
        {
          id: "title",
          sortable: true,
          name: "제목",
          excel_print: (v) => {
            return v.title;
          },
        },
        {
          id: "writerName",
          sortable: true,
          name: "작성자",
          excel_print: (v) => {
            return v.writerName;
          },
        },
        {
          id: "due_at",
          sortable: true,
          name: "제출완료일",
          excel_print: (v) => {
            return v.due_at;
          },
        },
        {
          id: "created_at",
          sortable: true,
          name: "등록일",
          excel_print: (v) => {
            return v.created_at;
          },
        },
      ],
    },
  }),
  beforeMount() {
    this.config.req_endpoint = "/boards/teacher/articles";
    this.config.grid_parser = async (data) => {
      this.etc = data.etc;
      this.config.name = data.etc.board.title;
      return {
        records: data.result,
        total: data.total,
      };
    };
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        if (!this.$route.params.board) return;
        this.config.req_endpoint = "/boards/teacher/articles";
        this.$refs.qg.search();
      }
    },
  },
};
</script>
